export default __webpack_public_path__ + "static/media/04.b971d045.png";